import { render, staticRenderFns } from "./TitleRemark.vue?vue&type=template&id=794a09da&scoped=true&"
import script from "./TitleRemark.vue?vue&type=script&lang=js&"
export * from "./TitleRemark.vue?vue&type=script&lang=js&"
import style0 from "./TitleRemark.vue?vue&type=style&index=0&id=794a09da&prod&scoped=true&lang=css&"
import style1 from "./TitleRemark.vue?vue&type=style&index=1&id=794a09da&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794a09da",
  null
  
)

export default component.exports